const SNSBtnStyles = {
  btnContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 60,
    height: 60,
    margin: 3,
    borderRadius: "50%",
    boxShadow: "1px 3px 3px 0px rgba(0, 0, 0, 0.3)",
    "&:hover": {
      cursor: "pointer",
      transition: "all .35s",
      transform: "scale(1.1, 1.1)",
      opacity: "0.6",
    },
  },
  icon: {
    fontSize: 33,
    color: "white",
  },
};
export default SNSBtnStyles;
